export class Schedule {
    id?: any;
    name: string;//100
    companyId?: string | number;
    description: string;//200
    userId: string;//number
    enable?: boolean;
    days: ScheduleDay[];
    start_tolerance?: string;
    end_tolerance?: string;
    is_flexible?: boolean
}

export class ScheduleDay {
    name: string;
    start: string;//00:00 a :23:59
    end: string;//00:00 a :23:59
}

export class ScheduleDynamic {

    nameDay: string;
    keyDay: string;
    startHour: string;
    endHour: string;
    valueToBack: string;
    selected: boolean;
    isCorrect: boolean;

}

export class ScheduleTolerance {
    startHour?: string;
    endHour?: string;
    isCorrect?: boolean;
}